import React from 'react';

import { PostQuestionSuccessModal } from './PostQuestionSuccessModal/PostQuestionModal';
import { SlDiscussContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { DeleteQuestionModal } from './DeleteQuestionModal/DeleteQuestionModal';
import { DeleteReplyModal } from './DeleteReplyModal/DeleteReplyModal';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

export function ModalsWrapper() {
	const {
		showPostQuestionSuccessModal$: showPostQuestionSuccessModal,
		showDeleteQuestionModal$: showDeleteQuestionModal,
		showDeleteReplyModal$: showDeleteReplyModal,
	} = useContainerData(SlDiscussContext, SlDataService, [
		'showPostQuestionSuccessModal$',
		'showDeleteQuestionModal$',
		'showDeleteReplyModal$',
	]);

	return (
		<>
			{showPostQuestionSuccessModal && <PostQuestionSuccessModal />}
			{showDeleteQuestionModal && <DeleteQuestionModal />}
			{showDeleteReplyModal && <DeleteReplyModal />}
		</>
	);
}
